import { z } from 'zod';
import { defineEndpoint } from '../define';
import { DeviceFileGroupSchema } from '../device-file-groups';
import { DeviceFileSchema } from '../device-files';
import { AssignmentHistorySchema, DeviceRowSchema } from './shapes';

export const DeviceDetailSchema = DeviceRowSchema.extend({
  assignmentHistory: z.array(AssignmentHistorySchema),
  files: z.array(DeviceFileSchema),
  fileGroups: z.array(DeviceFileGroupSchema),
});

export const GetDeviceResponseSchema = z.object({
  data: DeviceDetailSchema,
});

export const getDevice = defineEndpoint({
  method: 'GET',
  path: '/v1/devices/:deviceId',
  params: z.object({ deviceId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: GetDeviceResponseSchema,
});
